import { useState } from 'react';
import { api, setToken } from '../lib/api';
import { MountainScene } from '../components/MountainScene';

export function Login({ onSuccess }: { onSuccess: () => void }) {
  const [user, setUser] = useState('');
  const [pw, setPw] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(false);

  const submit = async () => {
    if (!user.trim() || !pw || busy) return;
    setBusy(true);
    setErr(false);
    try {
      const { token } = await api.login(user.trim(), pw);
      setToken(token);
      onSuccess();
    } catch {
      setErr(true);
      setBusy(false);
    }
  };

  const field =
    'w-full rounded-xl border bd surface-2 px-3.5 py-2.5 text-sm text-fg outline-none placeholder-faint transition focus:bd-strong';

  return (
    <div className="relative h-dvh overflow-clip">
      <MountainScene />
      <div className="relative z-10 flex h-full items-center justify-center px-6">
        <div className="glass glass-strong w-full max-w-sm rounded-[24px] p-8 text-center">
          <img src="/icons/pwa-192.png" alt="" className="mx-auto h-12 w-12 rounded-xl" />
          <div className="font-display mt-4 text-3xl tracking-[0.25em] text-fg">Claudio</div>
          <div className="mt-1.5 text-sm text-muted">你的私人电台</div>

          <input
            value={user}
            autoFocus
            autoCapitalize="none"
            autoCorrect="off"
            onChange={(e) => {
              setUser(e.target.value);
              setErr(false);
            }}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
            placeholder="账号"
            className={`${field} mt-8`}
          />
          <input
            type="password"
            value={pw}
            onChange={(e) => {
              setPw(e.target.value);
              setErr(false);
            }}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
            placeholder="密码"
            className={`${field} mt-3`}
          />
          {err && <div className="mt-3 text-xs text-seal">对不上——账号或密码不对</div>}
          <button
            onClick={submit}
            disabled={busy}
            className="accent-grad text-on-accent mt-5 w-full rounded-xl px-4 py-2.5 text-sm font-semibold transition disabled:opacity-50"
          >
            {busy ? '开门中…' : '进来听'}
          </button>
        </div>
      </div>
    </div>
  );
}
